module.exports = __webpack_public_path__ + "img/easter.aa56e22f.webp";